import React, { useState } from 'react';
import Modal from 'react-modal';
import Loader from 'react-loader-spinner';

import './index.scss';
import Styled from './styles';
import { Typography } from '../../../typography';
import { MODAL_TYPES, useGlobalModalContext } from '../..';
import { useUtils } from '../../../../core/hooks/useUtils';
import { addSnapAction } from '../../../../store/Snaps/action';
import colors from '../../../../assets/colors';
import CloseIcon from "@material-ui/icons/Close";

interface HookState {
	isLoading: boolean;
	text: string;
}

const loaderSize = 24;

export const AskModal = () => {
	const { showModal, hideModal, store } = useGlobalModalContext();
	const { dispatch } = useUtils();
	const { modalProps } = store || {};
	const { styles } = modalProps || {};

	const [state, setState] = useState<HookState>({
		isLoading: false,
		text: '',
	});

	const handleModalToggle = () => {
		hideModal();
	};

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
		setState(prev => ({
			...prev,
			text: e.target.value,
		}));
	};

	const onAddSnap = () => {
		if (!text.trim()) return;
		toggleLoader();
		dispatch(
			addSnapAction({
				text,
				showSuccessModal: () => {
					toggleLoader();
					handleModalToggle();
					showModal(MODAL_TYPES.SUCCESS_MODAL, {
						title: 'Snap has been successfully added',
						confirmBtn: 'Continue',
					});
				},
				showFailModal,
			})
		);
	};

	const showFailModal = () => {
		toggleLoader();
		handleModalToggle();
		showModal(MODAL_TYPES.FAIL_MODAL, {
			title: 'No Results',
			confirmBtn: 'Okay',
		});
	};

	const toggleLoader = () => {
		setState(prev => ({
			...prev,
			isLoading: !prev.isLoading,
		}));
	};

	const { isLoading, text } = state;

	return (
		<Modal
			isOpen={true}
			className={'Ask'}
			style={styles}
			onRequestClose={handleModalToggle}
			shouldCloseOnEsc
			shouldCloseOnOverlayClick
		>
			<Styled.ModalContent>
				<Styled.Close onClick={handleModalToggle}>
					<CloseIcon style={{ color: colors.black }} />
				</Styled.Close>
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						width: '100%',
					}}
				>
					<Styled.Input
						autoFocus
						placeholder={'Add new request'}
						onChange={handleChange}
						value={text}
					/>
					<Styled.Button onClick={onAddSnap} disabled={isLoading}>
						{isLoading ? (
							<Loader
								type="TailSpin"
								color={colors.black}
								height={loaderSize}
								width={loaderSize}
							/>
						) : (
							<Typography type="bold" text={"Let's go"} />
						)}
					</Styled.Button>
				</div>
			</Styled.ModalContent>
		</Modal>
	);
};
